import { useEffect, useState } from "react";
import Table from "react-bootstrap/Table";
import Card from "react-bootstrap/Card";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Container, Row, Col } from "react-bootstrap";
import UpsertClinicModal from "./AddUpdateClinicsModal";
import { DoctorService } from "../../services";

function ClinicsList() {
  const emptyClinic = {
    Id: 0,
    ClinicName: "",
    Adres: "",
    Phone1: "",
    email: "",
    VD: "",
    InvoiceTitle: "",
    InvoiceAddress: "",
    TCVN: "",
  };

  const [selectedClinic, setSelectedClinic] = useState(emptyClinic);
  const [showUpsertModal, setShowUpsertModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const handleClose = () => {
    setSelectedClinic(emptyClinic);
    setShowDetailsModal(false);
  };
  const [clinicsList, setClinicList] = useState([]);
  const [callUseEffect, setCallUseEffect] = useState(false);
  const navigate = useNavigate();

  const deleteClinic = (Id) => {
    DoctorService.deleteClinic(Id).then((response) => {
      setCallUseEffect(!callUseEffect);
    });
  };

  useEffect(() => {
    DoctorService.getClinicsList().then((response) => setClinicList(response));

    return () => {};
  }, [showUpsertModal, callUseEffect]);

  function render_row(item) {
    return (
      <div key={item.Id}>
        <Card border="Primary" className="col-12 col-md-6">
          <Card.Body>
            <Card.Title>{item.ClinicName}</Card.Title>
            <Card.Subtitle className="mb-2 text-muted">
              {item.Phone1}
            </Card.Subtitle>
            <Card.Text>{item.Adres}</Card.Text>
            <Card.Link
              onClick={() => {
                setSelectedClinic(item);
                setShowDetailsModal(true);
              }}
              href="#"
            >
              Details
            </Card.Link>
            <Card.Link
              onClick={() => {
                setSelectedClinic(item);
                setShowUpsertModal(true);
              }}
              href="#"
            >
              Edit
            </Card.Link>
            <Card.Link
              onClick={() => {
                deleteClinic(item.Id);
              }}
              href="#"
            >
              Delete
            </Card.Link>
          </Card.Body>
        </Card>
        <br />
      </div>
    );
  }

  return (
    <>
      <div>
        <Row>
          <Col className="col-6 col-md-3">
            <h3>Clinics</h3>
          </Col>
          <Col className="mb-2" style={{ textAlign: "right" }}>
            <Button
              variant="primary"
              onClick={() => {
                setSelectedClinic(emptyClinic);
                setShowUpsertModal(true);
              }}
            >
              Add New
            </Button>
          </Col>
        </Row>

        {clinicsList.map((item) => {
          return render_row(item);
        })}
      </div>
      <Modal centered show={showDetailsModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Clinic Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Row>
              {" "}
              <Col> Clinic Name: </Col>{" "}
              <Col> {selectedClinic && selectedClinic.ClinicName} </Col>
            </Row>
            <Row>
              {" "}
              <Col> Address: </Col>{" "}
              <Col> {selectedClinic && selectedClinic.Adres} </Col>{" "}
            </Row>
            <Row>
              <Col> Phone:</Col>{" "}
              <Col> {selectedClinic && selectedClinic.Phone1} </Col>
            </Row>
            <Row>
              {" "}
              <Col> Email: </Col>{" "}
              <Col> {selectedClinic && selectedClinic.email} </Col>{" "}
            </Row>
            <Row>
              {" "}
              <Col> Invoice Title: </Col>{" "}
              <Col> {selectedClinic && selectedClinic.InvoiceTitle} </Col>{" "}
            </Row>
            <Row>
              {" "}
              <Col> Invoide Address: </Col>{" "}
              <Col> {selectedClinic && selectedClinic.InvoiceAddress} </Col>{" "}
            </Row>
            <Row>
              {" "}
              <Col> VD: </Col>{" "}
              <Col> {selectedClinic && selectedClinic.VD} </Col>{" "}
            </Row>
            <Row>
              {" "}
              <Col> TC/VN: </Col>{" "}
              <Col> {selectedClinic && selectedClinic.TCVN} </Col>{" "}
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <UpsertClinicModal
        show={showUpsertModal}
        clinic={selectedClinic}
        setShowUpsertModal={setShowUpsertModal}
      ></UpsertClinicModal>
    </>
  );
}

export default ClinicsList;
